module.exports = __webpack_public_path__ + "img/pepper-large.c94195be.svg";